module.exports = __webpack_public_path__ + "img/project_full_delete.45629292.png";